import axios from '@findy-code/yuffie/axios';
import { toast } from '@findy-code/yuffie/ui/toast';
import { setUserIdToGaSendEventObj } from '@findy-code/yuffie/utils/events/event';
import { useCallback } from 'react';

export const useLogoutFacade = () => {
  const handleLogout = useCallback(async () => {
    const url = '/api/v1/candidate/session';
    return axios
      .delete(url)
      .then(() => {
        setUserIdToGaSendEventObj(undefined);
        // 強制リロードを行いたいのでuseRouterは利用しない
        window.location.href = '/';
      })
      .catch(() => {
        toast.error('ログアウトに失敗しました。');
      });
  }, []);

  return { handleLogout } as const;
};
